/**
 * All saga listeners must be added here to that Redux-Saga may run them.
 *
 * See https://github.com/hozana/hozana.org-v2/blob/develop/docs/3-functionnalities/redux.md
 */

import routinePromiseWatcherSaga from '@hozana/routines/routinePromiseWatcherSaga'

import authSagasListener from 'modules/auth/sagas'
import intentionSagasListener from 'modules/intention/sagas'
import praySagasListener from 'modules/pray/sagas'

const getAllSagas = () => [
  authSagasListener(),
  intentionSagasListener(),
  praySagasListener(),
  // Utils
  routinePromiseWatcherSaga(),
]

export default getAllSagas
